import { styled } from '@mui/material/styles';
import { AuthorRoles } from './ChatMessage.constants';

export const MessageRow = styled('div')<{ error?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  cursor: ${({ error }) => error && 'pointer'};
  transition: background-color 0.3s ease;

  &.highlight {
    background-color: ${({ theme }) => theme.palette.action.hover};
    border-radius: 0.4rem;
  }

  i.status-icon {
    position: absolute;
    bottom: 0.6rem;
    right: 1.6rem;
    color: ${({ theme, error }) => (error ? theme.palette.error.main : theme.palette.neutral.var50)};
  }
`;

export const MessageWrapper = styled('div', {
  shouldForwardProp: (propName) => propName !== 'authorRole',
})<{
  authorRole?: string;
}>`
  position: relative;
  display: flex;
  flex-direction: ${({ authorRole }) => (authorRole === AuthorRoles.USER ? 'row' : 'row-reverse')};
  width: fit-content;
  overflow-wrap: anywhere;
  min-width: 16.8rem;
  align-items: flex-start;
  align-self: ${({ authorRole }) => authorRole !== AuthorRoles.USER && 'flex-end'};

  ${({ theme }) => `
    ${theme.breakpoints.down('md')} {
      max-width: 30.4rem;
    }
    ${theme.breakpoints.up('md')} {
      max-width: 39.2rem;
    }
    ${theme.breakpoints.up('lg')} {
      max-width: 46.4rem;
    }
    ${theme.breakpoints.up('xl')} {
      max-width: 52rem;
    }
  `}

  &:hover .messageOptions,
  &:focus-within .messageOptions,
  &[data-show-actions='true'] .messageOptions {
    visibility: visible;
  }

  .MuiStack-root {
    margin-top: 0;
    min-width: unset;
  }
`;

export const InfoArea = styled('div')`
  margin-bottom: 0.8rem;
  padding: 0 0.8rem;
`;

export const ErrorMessage = styled('div')`
  color: ${({ theme }) => theme.palette.error.main};
  margin-left: auto;
  margin-right: 0.8rem;
  margin-top: 0.2rem;
`;
